<template>
  <div id="mb-path-checker" class="mb-path-checker">
    <img
      v-if="startGameConfig.mainImage"
      class="main-img"
      draggable="false"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        width: setMainImageValue(startGameConfig.mainImage.width, 1920) + 'px',
        height: setMainImageValue(startGameConfig.mainImage.height, 1080) + 'px',
        top: setMainImageValue(startGameConfig.mainImage.pos.y, 0) + 'px',
        left: setMainImageValue(startGameConfig.mainImage.pos.x, 0) + 'px',
      }"
    />
    <img
      v-if="startGameConfig.image"
      class="main-img"
      draggable="false"
      :src="giveMeImagePlease(startGameConfig.image.imagePath)"
      :style="{
        width: setMainImageValue(startGameConfig.image.width, 1920) + 'px',
        height: setMainImageValue(startGameConfig.image.height, 1080) + 'px',
        top: setMainImageValue(startGameConfig.image.pos.y, 0) + 'px',
        left: setMainImageValue(startGameConfig.image.pos.x, 0) + 'px',
      }"
    />
    <svg
      style="top: 0; left: 0; position: absolute"
      width="1920px"
      height="1080px"
      :viewBox="'0 0 ' + 1920 + ' ' + 1080"
    >
      <!-- <defs>
        <marker id="dot" viewBox="0 0 10 10" refX="5" refY="5" markerWidth="2" markerHeight="2">
          <circle cx="5" cy="5" r="3" fill="red" />
        </marker>
      </defs>-->

      <polyline
        @click="delPath(index)"
        :points="draw.path"
        style="cursor: pointer; stroke-linecap: round; stroke-linejoin: bevel"
        fill="none"
        :stroke="draw.stroke"
        stroke-opacity="1"
        :stroke-width="draw.strokeWidth"
        v-for="(draw, index) in drawingPath"
        :key="'draw-path-' + index"
      />
    </svg>
    <div
      id="drawing-place"
      style="
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: white;
        opacity: 0;
        cursor: crosshair;
        z-index: 3;
      "
      @mousemove.self="onMouseMove($event, false)"
      @mousedown="
        drawNow = true;
        pathCheckStatus = true;
      "
      v-if="end && start && path"
      @mouseup="endOfPath()"
      @touchmove.passive="onMouseMove($event, true)"
      @touchstart="
        drawNow = true;
        pathCheckStatus = true;
      "
      @touchend="endOfPath()"
    ></div>
    <div
      id="drawing-place"
      style="
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: white;
        opacity: 0;
        cursor: crosshair;
        z-index: 3;
      "
      @mousemove.self="onMouseMoveWithoutCheck($event, false)"
      @mousedown="
        drawNow = true;
        pathCheckStatus = true;
      "
      v-if="!end && !start && !path"
      @mouseup="endOfPath()"
      @touchmove.passive="onMouseMoveWithoutCheck($event, true)"
      @touchstart="
        drawNow = true;
        pathCheckStatus = true;
      "
      @touchend="endOfPath()"
    ></div>
    <svg
      id="svg-path-check"
      style="top: 0; left: 0; position: absolute"
      width="100%"
      v-if="end && start && path"
      height="100%"
      :style="{ 'z-index': '1', opacity: 0.3 }"
      :viewBox="'0 0 ' + 1920 + ' ' + 1080"
    >
      <path
        id="path-check"
        :stroke="path.stroke"
        style="stroke-linecap: round; stroke-linejoin: round"
        fill="transparent"
        stroke-width="40"
        :d="path.path"
      />
      <circle
        id="start-point"
        :cx="start.cx"
        :cy="start.cy"
        :r="start.r"
        :style="{
          cx: start.cx,
          cy: start.cy,
          r: start.r,
        }"
        stroke="transparent"
        :fill="start.fill"
      />
      <circle
        id="end-point"
        :cx="end.cx"
        :cy="end.cy"
        :r="end.r"
        :style="{
          cx: end.cx,
          cy: end.cy,
          r: end.r,
        }"
        stroke="transparent"
        :fill="end.fill"
      />
    </svg>
    <div class="select-items" v-if="colors.length > 0" :style="itemsPosition">
      <div
        v-for="(selIt, selItIndex) in colors"
        class="select-item"
        @click="setColor(selIt)"
        :key="'selected-items-' + selItIndex"
        :style="[{ background: selIt }, strokeLineColor == selIt ? { opacity: 1 } : { opacity: 0.5 }]"
      ></div>
    </div>
  </div>
</template>
<script>
import defaultMixin from '../../mixins/defaultMixin';
import _ from 'lodash';
import { Howler } from 'howler';
export default {
  name: 'mb-path-checker',
  components: {},
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      drawBlock: false,
      start: {},
      path: {},
      end: {},
      gameState: false,
      canIDraw: true,
      drawNow: false,
      drawingPath: [{ path: '', strokeWidth: 1, stroke: 'black', opacity: 1 }],
      lastPos: {
        x: -100,
        y: -100,
      },
      pathCheckStatus: false,
      pathCheckBetween: [],
      strokeLineWidth: 1,
      strokeLineColor: 'black',
      strokePosition: 'bottom',
      colors: [],
    };
  },
  beforeMount() {
    this.init();
  },
  methods: {
    setColor(col) {
      this.strokeLineColor = col;
      this.drawingPath[this.drawingPath.length - 1].stroke = col;
    },
    creatBetweenPoints() {
      this.pathCheckBetween = [];
      let svgPoints = document.getElementsByClassName('between-points');
      for (let item of svgPoints) {
        this.pathCheckBetween.push({
          x: parseInt(item.getAttribute('cx')),
          y: parseInt(item.getAttribute('cy')),
          pass: false,
        });
      }
      console.log(this.pathCheckBetween);
    },
    setMainImageValue(value, defaultValue) {
      if (value) return value;
      else return defaultValue;
    },
    endOfPath() {
      // this.active.path = false;
      this.drawNow = false;
      this.drawingPath.push({
        path: '',
        strokeWidth: this.strokeLineWidth,
        stroke: this.strokeLineColor,
        opacity: this.opacity,
      });
      if (this.end && this.start && this.path) {
        if (this.svgPathCheckEndPoint(this.lastPos.x, this.lastPos.y)) {
          console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!' + this.pathCheckStatus);
          if (this.pathCheckStatus) {
            this.drawBlock = true;
            this.$store.dispatch('checkGame');
          }
        } else {
          this.pathCheckStatus = false;
          console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!' + false);
        }
      }

      // this.pathCheckStatus = true;
      // this.drawingPath = drawingPath + 'M ';
    },
    svgPathCheckStartPoint(posX, posY) {
      let test = document.getElementById('start-point');
      let svg = document.getElementById('svg-path-check');
      let point = svg.createSVGPoint();
      point.x = Math.round(posX);
      point.y = Math.round(posY);
      // console.log('Point at ' + posX + ' : ' + posY, test.isPointInStroke(point));
      console.log('start: ' + test.isPointInFill(point));
      return test.isPointInFill(point);
    },
    svgPathCheckEndPoint(posX, posY) {
      let test = document.getElementById('end-point');
      let svg = document.getElementById('svg-path-check');
      let point = svg.createSVGPoint();
      point.x = Math.round(posX);
      point.y = Math.round(posY);
      // console.log('Point at ' + posX + ' : ' + posY, test.isPointInStroke(point));
      console.log('end: ' + test.isPointInFill(point));
      return test.isPointInFill(point);
    },
    svgPathCheck(posX, posY) {
      if (this.pathCheckStatus) {
        let test = document.getElementById('path-check');
        let svg = document.getElementById('svg-path-check');
        let point = svg.createSVGPoint();
        point.x = Math.round(posX);
        point.y = Math.round(posY);
        // console.log('Point at ' + posX + ' : ' + posY, test.isPointInStroke(point));
        if (!test.isPointInStroke(point)) {
          this.pathCheckStatus = false;
          console.log(posX + ':' + posY);
        }
      }
    },
    onMouseMove(e, touch) {
      if (!this.drawBlock) {
        if ((this.canIDraw && this.drawNow) || touch) {
          this.canIDraw = false;
          let rect = document.getElementById('drawing-place').getBoundingClientRect();
          let posX = ((e.clientX - rect.left) / rect.width) * 1920;
          let posY = ((e.clientY - rect.top) / rect.height) * 1080;
          if (touch) {
            posX = ((e.targetTouches[0].clientX - rect.left) / rect.width) * 1920;
            posY = ((e.targetTouches[0].clientY - rect.top) / rect.height) * 1080;
          }
          if (this.drawingPath[this.drawingPath.length - 1].path == '') {
            this.pathCheckStatus = this.svgPathCheckStartPoint(posX, posY);
          }
          this.svgPathCheck(posX, posY);
          if (this.checkPos(posX, posY)) {
            if (this.rubberMode) {
              this.rubberPoints[this.rubberPoints.length - 1].path =
                this.rubberPoints[this.rubberPoints.length - 1].path + posX + ', ' + posY + ' ';
            } else {
              this.lastPos.x = posX;
              this.lastPos.y = posY;
              this.drawingPath[this.drawingPath.length - 1].path =
                this.drawingPath[this.drawingPath.length - 1].path + posX + ', ' + posY + ' ';
            }
          }
          setTimeout(() => {
            this.canIDraw = true;
          }, 10);
        }
      }
    },
    onMouseMoveWithoutCheck(e, touch) {
      if (!this.drawBlock) {
        if ((this.canIDraw && this.drawNow) || touch) {
          this.canIDraw = false;
          let rect = document.getElementById('drawing-place').getBoundingClientRect();
          let posX = ((e.clientX - rect.left) / rect.width) * 1920;
          let posY = ((e.clientY - rect.top) / rect.height) * 1080;
          if (touch) {
            posX = ((e.targetTouches[0].clientX - rect.left) / rect.width) * 1920;
            posY = ((e.targetTouches[0].clientY - rect.top) / rect.height) * 1080;
          }
          this.lastPos.x = posX;
          this.lastPos.y = posY;
          this.drawingPath[this.drawingPath.length - 1].path =
            this.drawingPath[this.drawingPath.length - 1].path + posX + ', ' + posY + ' ';
          setTimeout(() => {
            this.canIDraw = true;
          }, 10);
        }
      }
    },
    svgPathCheckStart(posX, posY) {
      if (this.pathCheckStatus) {
        let svgStartPoint = document.getElementById('start-point');
        if (
          posX - parseInt(svgStartPoint.getAttribute('cx')) >= -30 &&
          posX - parseInt(svgStartPoint.getAttribute('cx')) <= 30 &&
          posY - parseInt(svgStartPoint.getAttribute('cy')) >= -30 &&
          posY - parseInt(svgStartPoint.getAttribute('cy')) <= 30
        )
          return true;
        else return false;
      }
    },
    checkPos(posX, posY) {
      if (
        this.lastPos.x - posX > 30 ||
        this.lastPos.x - posX < 30 ||
        this.lastPos.y - posY > 30 ||
        this.lastPos.y - posY < 30
      ) {
        return true;
      } else return false;
    },
    svgPathCheckEnd(posX, posY) {
      if (this.pathCheckStatus) {
        let svgEndPoint = document.getElementById('end-point');
        // console.log(posX + ':X:' + parseInt(svgEndPoint.getAttribute('cx')));
        // console.log(posY + ':Y:' + parseInt(svgEndPoint.getAttribute('cy')));
        if (
          posX - parseInt(svgEndPoint.getAttribute('cx')) >= -30 &&
          posX - parseInt(svgEndPoint.getAttribute('cx')) <= 30 &&
          posY - parseInt(svgEndPoint.getAttribute('cy')) >= -30 &&
          posY - parseInt(svgEndPoint.getAttribute('cy')) <= 30
        )
          return true;
        else return false;
      }
    },
    init() {
      this.start = this.startGameConfig.start;
      this.path = this.startGameConfig.path;
      this.end = this.startGameConfig.end;
      this.strokeLineWidth = this.startGameConfig.strokeWidth;
      this.drawingPath[0].strokeWidth = this.startGameConfig.strokeWidth;
      this.strokePosition = this.startGameConfig.strokePosition || 'bottom';
      if (Array.isArray(this.startGameConfig.stroke)) {
        this.drawingPath[0].stroke = this.startGameConfig.stroke[0];
        this.strokeLineColor = this.startGameConfig.stroke[0];
        this.colors = this.startGameConfig.stroke;
      } else {
        this.drawingPath[0].stroke = this.startGameConfig.stroke;
        this.strokeLineColor = this.startGameConfig.stroke;
      }
      if (this.startGameConfig.mainImage) {
        if (this.startGameConfig.mainImage.images) {
          let img = this.shuffle(this.startGameConfig.mainImage.images);
          this.startGameConfig.mainImage.imagePath = img[0];
        }
      }
      if (this.startGameConfig.image) {
        if (this.startGameConfig.image.images) {
          let imgTmp = this.shuffle(this.startGameConfig.image.images);
          this.startGameConfig.image.imagePath = imgTmp[0];
        }
      }
    },
    cancelCheck() {
      this.gameState = false;
      this.$store.commit('CHANGE_CHECK_SWITCH', false);
    },
    checkGameAction() {
      return this.pathCheckStatus;
    },
    resetGameAction() {
      this.gameState = false;
      this.canIDraw = true;
      this.drawNow = false;
      this.drawBlock = false;
      this.drawingPath = [{ path: '', strokeWidth: 1, stroke: 'black', opacity: 1 }];
      this.lastPos = {
        x: -100,
        y: -100,
      };
      this.pathCheckStatus = false;
      this.strokeLineWidth = 1;
      this.strokeLineColor = 'black';
      this.colors = [];
      this.init();
    },

    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    randomNumber(x, n) {
      return Math.floor(Math.random() * x) + n;
    },
    getRandomColor() {
      let letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
  },
  beforeDestroy() {},
  computed: {
    backgroundImageUrl() {
      return 'static/' + this.startGameConfig.background;
    },
    itemsPosition() {
      switch (this.strokePosition) {
        case 'right':
          return {
            top: '0',
            right: '0',
            width: '120px',
            height: '100%',
            'flex-direction': 'column',
            'align-items': 'center',
            'justify-content': 'center',
          };

        case 'left':
          return {
            top: '0',
            left: '0',
            width: '120px',
            height: '100%',
            'flex-direction': 'column',
            'align-items': 'center',
            'justify-content': 'center',
          };
          break;
        case 'bottom':
        default:
          return {
            width: '100%',
            bottom: '0',
            left: '0',
            height: '120px',
            'flex-direction': 'row',
            'align-items': 'center',
            'justify-content': 'center',
          };
      }
    },
  },
};
</script>
<style lang="sass" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
$backgroundWidth: 1906px
$backgroundHeight: 1030px
$backgroundOffsetTop: 140px
$backgroundOffsetLeft: 0
.main-img
  position: fixed
  object-fit: cover
.curtain
  position: absolute
  top: 0
  width: 1920px
  height: 1080px
  left: 0
  z-index: 2
.mb-path-checker
  background-size: contain
  background-repeat: no-repeat
  position: relative
  left: $backgroundOffsetLeft
  overflow: hidden
  height: 100%
  width: 100%
  top: 0px
  display: flex
  align-items: center
  flex-direction: column
  justify-content: center
.select-items
  position: absolute
  display: flex
  .select-item
    margin: 20px
    border: 8px solid white
    display: flex
    align-items: center
    justify-content: center
    width: 100px
    height: 100px
    background: white
    border-radius: 10px
    box-shadow: 0px 0px 7px rgba(0,0,0, 0.2)
    font-family: $gameFontFamily
    cursor: pointer
    font-size: 34px
    transition: .5s
    z-index: 7
    &:hover
      opacity: 1
      box-shadow: 0px 0px 9px rgba(0,0,0, 0.8)
.img-fade-leave-active, .img-fade-enter-active
  transition: all .5s linear
.img-fade-leave-to, .img-fade-enter
  opacity: 0
.img-check-fade-leave-active
  transition: all .1s .5s linear
.img-check-fade-enter-active
  transition: all .3s linear
.img-check-fade-leave-to, .img-check-fade-enter
  opacity: 0
</style>
